import { NavigationEnd, RouterLink } from "@angular/router";
import { SlideHideCondition, SlideHideConditionType, SlideHidePageCondition, TutorialSlide } from "./tutorial.models";
// import { TutorialService } from "./tutorial.service";
import { Router } from "@angular/router";

//Will change it when I find a way to get these defaults from the groupUtils
const DEFAULT_AUDIO_CONSENT = 'I hereby grant permission for the use of audio recordings during my medical consultations, procedures, and any other service interactions. I understand that these recordings will be used solely for the purpose of enhancing the quality of care, ensuring accuracy of medical records, and for training and educational purposes within the healthcare facility. I acknowledge that all recordings will be stored securely and will be accessible only to authorized personnel. I authorise my healthcare provider to utilise MedicAI to assist with note generation. I retain the right to revoke this consent at any time.';
const DEFAULT_INFO_STORAGE_CONSENT = 'I consent to the electronic storage of my personal health information (PHI) by the healthcare facility. I understand that this includes, but is not limited to, medical records, test results, and notes from healthcare providers. I acknowledge that the facility uses secure, encrypted systems to protect my privacy and confidentiality in accordance with applicable privacy laws. I have the right to request a copy of my records and can revoke this consent in writing at any time.';
const DEFAULT_BILLING_POLICY = '1. This practice charges the fees it regards as appropriate in terms of the experience, services and training of the professionals working in the practice, as well as the cost base of the practice. Competition law dictates that practices may not agree to charge the same or similar fees.\n\n2. The general fees charged for the most common codes we charge is available upon request from reception.\n\n3. Fees may be / are increased on an annual basis and patients will be notified of this when making their appointment.\n\n4. The practice will provide patients with a price of goods and/or services, and where it is unable to do so, it will provide a cost estimate to the patient. It should be noted that healthcare is not an exact numerical science, and the duration of services, or the number of items used cannot always be exactly estimated. In some cases the amount of medicine needed are calculated on the specific patient\'s needs and factors such as, for example, weight, age and severity of condition.\n\n5. In many cases other health facilities, such as hospitals, theatre\'s, clinics, other doctors (such as anaesthetists, pathologists, etc.), or other healthcare professionals (occupational therapists, physiotherapists, etc.) will be involved in the patient\'s healthcare. Such facilities and professionals will charge their own fees in addition to the fees of this practice if they also render healthcare services to you.\n\n6. We may contract to certain medical schemes (or medical scheme options) in a particular year. In such cases we will be obliged to charge at the levels so agreed with that scheme.\n\n7. Note that unless we have agreed fees with your medical scheme, the fees that we charge and the benefits awarded by your scheme may not overlap. This would mean that you may be required to pay the difference, or in some cases, depending on the patient\'s medical scheme, pay for the treatment in full. Should you feel aggrieved by the decisions of your medical scheme, you can approach the: Council for Medical Schemes at: Complaints@medicalschemes.com or fax (012) 431- 0608. Note that the CMS would want patients to exhaust internal remedies (appeals in the scheme) first.\n\n8. Also note that your medical scheme may require pre-authorisation and/or a motivation prior to certain treatments. Pre-authorisation or scheme approval is, according to schemes, no guarantee of payment.\n\n9. Should you (the patient, if you are an adult, or the parent of a child-patient) not pay your account within 30 business / calendar days, we will give you notice of 20 business days where after we will refer your account to [an attorney / a debt collecting agency]. This will attract additional collection- and other fees. We reserve the right to charge interest of 2% per month on overdue accounts.\n\n10. Please ensure that we always have your latest contact details to prevent you from missing any important communication from us. We may contact the person(s) indicated on your personal information form if we cannot get hold of you and your account remains unpaid.\n\n11. Patients are encouraged to approach us early on if they experience problems with the payment of the account.\n\n12. In deserving cases, we may reduce our fees to accommodate such patients. This practice also participates in various charitable activities.\n\n13. Employment, insurance, Road Accident Fund and Compensation Fund (workplace injuries/disease) are dealt with according to the specific rules set by such bodies. Please inform us should you fall into these categories so that we can explain billing in these cases to you.';
const DEFAULT_POPIA = '1. Consent\n\nI, hereby authorise, freely and voluntarily and with knowledge of the implications of such consent, the Practice to disclose the specific information outlined herein to the entities / person(s) mentioned and to the extent identified herein:\n\n2. What information is to be disclosed and for what reason?\n•	Another person(such as their parent, a spouse, etc.) sit in at the consultation / procedure. Such a person would then hear and / or see information that would otherwise remain confidential between the patient and healthcare practitioner.\n• Another person(such as family members) receive updates on how the patient is doing before, during and / or after a procedure, when in hospital / ICU, etc.\n• Another person or entity can get a copy of specific health records (e.g.a copy of the patient\'s file, a medical report, a copy of a sick certificate, etc.), prescription, etc.\n• Another health professional or health care provider for the purpose of patient communication and treatment\n• A person who can consent to treatment and care when the patient cannot (e.g.when the patient is unconscious), can receive information about the patient which will enable them to make the decision.\n• The employer be informed of specific aspects, e.g.the nature of the patient\'s illness, how long s/he would be away and why, etc. Patients take sole responsibility for any consequence that may flow from a disclosure to an employer.\n• An insurance company, which require the completion of form, and/or the drafting of a report.\n•	A pharmaceutical or medical device company for any treatment related services\n• A pharmaceutical or medical device company, to which details of a negative event associated with a product must be shared.\n• A medico-legal report, a report constituting a second opinion, a report to an attorney, etc.\n• All consultations are voice recorded.\n•	A Dialysis unit/Dialysis Unit manager, Rehabilitation centre, step down facility or any other after care service\n•	Copies of medical reports, consultation recordings, prescriptions, x-rays, ultrasounds and all other medical information can be kept both in hard copy and electronically by the practice.\n\n3. To which family member / spouse may the information be disclosed?\n\nInformation may be disclosed to persons listed as Next of Kin\n\n4. For how long is this consent valid?\n\nThis consent in valid for an indefinite period.\n\nPatients can withdraw this consent at any time bearing in mind that withdrawal may not be possible in certain instances without negatively affecting patients\' rights and contractual relationships, for which patient takes full liability and indemnifies the Practice.';

export function evaluateHideConditions(
    conditions: SlideHideCondition[],
    // tutorialService: TutorialService,
    slide: TutorialSlide,
    router: Router,
    {
        user,
        group,
        groupUsers,
        hospitals,
        medicationBundles,
        timeSettings,
        appointmentTypes,
        defaultConsentForm,
        customConsentForm,
        colleagues,
        codingBundles,
        noteTypes,
        hiddenSlides
    }: any): boolean {
    //console.log('EVALUATING CONDITIONS FOR: ', slide.key);
    const evaluateCondition = (condition: SlideHideCondition): boolean => {
        //console.log('FORCE TUTORIAL: ', user?.forceTutorial)
        if (user?.forceTutorial && !['Physiotherapy', 'Dietitian', 'Social Worker'].includes(group?.groupSpeciality)) {

            if (router.url === '/settings' && (group.userRole === 'Admin' || group.userRole === 'Physician')) {
                return false;
            }
            return true;
        }

        let shouldHide = false;
        switch (condition.condition) {
            case SlideHidePageCondition.IS_PHYSICIAN:
                // hide the slide if the user is a doctor
                shouldHide = user?.userType === 'doctor';
                // console.log(user?.userType, ': ', shouldHide);
                break;

            case SlideHidePageCondition.NOT_PHYSICIAN:
                // hide the slide if the user is not a doctor (even if they have admin rights)
                shouldHide = user?.userType !== 'doctor';
                break;

            case SlideHidePageCondition.NOT_PHYSICIAN_ROLE:
                // hide the slide if the user is not a doctor (even if they have admin rights)
                shouldHide = group.userRole !== 'Physician';
                break;

            case SlideHidePageCondition.NOT_ADMIN_USER:
                //hide the slide if the user is an admin staff account and they do not have admin rights
                const isAdminStaff = user?.userType !== 'doctor';
                shouldHide = isAdminStaff && group.userRole !== 'Admin';
                // console.log(group.userRole, ': ', shouldHide);
                break;

            case SlideHidePageCondition.SIGNATURE_SET:
                //hide the slide if the user has already created a siignature
                let signatureUrl = user?.signatureImageUrl
                if (user?.signatureImageUrl === null) {
                    signatureUrl = '';
                }
                shouldHide = signatureUrl !== '';
                //if (shouldHide) updateUserProgress(10);

                break;

            case SlideHidePageCondition.PRACTICE_PROFILE_COMPLETE:
                //hide the slide if the the practice profile has been completed
                shouldHide = (group?.about !== null && group?.about !== '');
                // if (shouldHide) updateUserProgress(5);

                break;

            case SlideHidePageCondition.NETWORK_COMPLETE:
                //hide the slide if there are already other users in the practice network
                const otherUsers = groupUsers?.filter((u: any) => u.userId !== user?.id && u.email !== 'contact@medicai.co.za');
                shouldHide = otherUsers.length !== 0;
                // if (shouldHide) updateUserProgress(5);

                break;

            case SlideHidePageCondition.HAS_HOSPITALS:
                //hide the slide if hospitals have already been created
                shouldHide = hospitals && hospitals?.length !== 0;
                // if (shouldHide) updateUserProgress(5);

                break;

            case SlideHidePageCondition.LETTERHEAD_SET:
                //hide the slide if the letterhead has already been set
                shouldHide = group?.headerImageUrl !== '';
                // if (shouldHide) updateUserProgress(10);

                break;

            case SlideHidePageCondition.MEDICATION_BUNDLES_CREATED:
                //hide the slide if medication bundles have already been created
                shouldHide = medicationBundles && medicationBundles?.length !== 0;
                // if (shouldHide) updateUserProgress(5);

                break;

            case SlideHidePageCondition.IS_ALLIED_SPECIALTY:
                //hide the slide if the user is a allied specialty
                shouldHide = ['Physiotherapy', 'Dietitian', 'Social Worker'].includes(group?.groupSpeciality);
                break;

            case SlideHidePageCondition.PREFERRED_MEDICATION_SET:
                //hide the slide if the user has already created their preferred medication list
                shouldHide = user?.preferredMedication && user?.preferredMedication?.length !== 0;
                // if (shouldHide) updateUserProgress(5);

                break;

            case SlideHidePageCondition.IS_STAFF:
                //hide the slide if the user is a normal group user
                const currentGUser = groupUsers?.filter((u: any) => u.userId === user?.id);
                shouldHide = user?.userType !== 'doctor' && currentGUser[0].userRole.toLowerCase() !== 'admin';
                break;

            case SlideHidePageCondition.SCHEDULE_COMPLETED:
                //hide the slide if the schedule settings have been configured
                shouldHide = (timeSettings.startTime !== '00:00' && timeSettings.endTime !== '23:59');
                // if (shouldHide) updateUserProgress(5);;

                break;

            case SlideHidePageCondition.APPOINTMENT_EDITED:
                //hide the slide if the appointment types have been modified
                shouldHide = (appointmentTypes?.length !== 3 || !appointmentTypes?.every((appointment: any) => ['First Consult', 'Theatre', 'Follow Up'].includes(appointment.type)))
                // if (shouldHide) updateUserProgress(3);
                break;

            case SlideHidePageCondition.DEFAULT_USER_CONSENT_FORM:
                //hide the slide if any of the default consent forms have been modified
                shouldHide = !defaultConsentForm.every((consent: any) => [DEFAULT_AUDIO_CONSENT, DEFAULT_BILLING_POLICY, DEFAULT_INFO_STORAGE_CONSENT, DEFAULT_POPIA].includes(consent.text));
                // if (shouldHide) updateUserProgress(2);

                break;

            case SlideHidePageCondition.CUSTOM_CONSENT_FORM:
                //hide the slide if any custom consent form has been created
                shouldHide = customConsentForm && customConsentForm.length !== 0;
                // if (shouldHide) updateUserProgress(4);

                break;

            case SlideHidePageCondition.COLLEAGUE_ADDED:
                //hide the slide if colleagues have been added
                shouldHide = colleagues && colleagues?.length !== 0;
                // if (shouldHide) updateUserProgress(6);

                break;

            case SlideHidePageCondition.CODING_BUNDLES_ADDED:
                //hide the slide if coding bundles have been added and they all contain procedure codes
                shouldHide = !codingBundles.every((codingBundle: { procedureCodes: string[] }) => codingBundle.procedureCodes.length === 0,);
                // if (shouldHide) updateUserProgress(2);

                break;

            case SlideHidePageCondition.AUTO_WARD_BUNDLES_ADDED:
                //hide the slide if hospitals have been created and auto coding has been assigned to each ward
                shouldHide = hospitals.length !== 0 && hospitals.some((hospital: { wards: { procedureCodes: string[] }[] }) =>
                    hospital.wards.some((ward: { procedureCodes: string[] }) =>
                        ward.procedureCodes?.length !== 0
                    )
                );
                // if (shouldHide) updateUserProgress(3);

                break;

            case SlideHidePageCondition.COMMON_MODIFIER_ADDED:
                //hide the slide if the common modifiers list has been edited
                shouldHide = group?.practiceModifers.length !== 3;
                // if (shouldHide) updateUserProgress(3);

                break;

            case SlideHidePageCondition.CODING_FINISHED:
                //hide the slide if ALL coding settings have been completed
                const isCodingBundlesAdded = codingBundles.every((codingBundle: { procedureCodes: string[] }) =>
                    codingBundle.procedureCodes.length === 0
                );
                const isAutoWardBundlesAdded =
                    hospitals.length === 0 ||
                    hospitals.some((hospital: { wards: { procedureCodes: string[] }[] }) =>
                        hospital.wards.some((ward: { procedureCodes: string[] }) =>
                            ward.procedureCodes?.length === 0
                        )
                    );
                const isCommonModifierAdded = group?.practiceModifers.length === 3;
                shouldHide = isCodingBundlesAdded && isAutoWardBundlesAdded && isCommonModifierAdded;
                // if (shouldHide) updateUserProgress(2);

                break;

            case SlideHidePageCondition.DEFAULT_NOTES_ADDED:
                //hide the slide if headings have been edited in the default note types
                const totalHeadingsLength = noteTypes.reduce(
                    (sum: number, noteType: { headings: string[] }) => sum + noteType.headings.length,
                    0
                );
                shouldHide = totalHeadingsLength !== 47;
                // if (shouldHide) updateUserProgress(5);

                break;

            case SlideHidePageCondition.CUSTOM_NOTES_ADDED:
                //hide the slide if custom note types have been added
                shouldHide = noteTypes && noteTypes.length !== 7;
                // if (shouldHide) updateUserProgress(10);

                break;

            case SlideHidePageCondition.NOTES_FINISHED:
                //hide the slide if all note settings have been configured
                const totalHeadings = noteTypes.reduce(
                    (sum: number, noteType: { headings: string[] }) => sum + noteType.headings.length,
                    0
                );
                shouldHide = noteTypes && (noteTypes.length !== 7 || totalHeadings !== 47);
                // if (shouldHide) updateUserProgress(10);

                break;

            case SlideHidePageCondition.DIALOG_SLIDE_HIDDEN:
                //hide the slide if this slide has been marked as hidden
                hiddenSlides = user.hiddenSlides || [];
                shouldHide = hiddenSlides.includes(slide.key);
                // console.log(hiddenSlides, ': ', shouldHide)
                break;


            case SlideHidePageCondition.SCHEDULE_SLIDES_SEEN:
                //hide the slide if this slide has been marked as hidden
                shouldHide = user?.tutorialStatus?.allSeen || user?.tutorialStatus?.schedulingSeen;
                //console.log('result -> SCHEDULE_SLIDES_SEEN: ', user?.tutorialStatus?.allSeen, user?.tutorialStatus?.schedulingSeen, shouldHide)
                break;

            case SlideHidePageCondition.ADMITTING_SLIDE_SEEN:
                //hide the slide if this slide has been marked as hidden
                shouldHide = user?.tutorialStatus?.allSeen || user?.tutorialStatus?.dischargingSeen;
                //console.log('result -> ADMITTING_SLIDE_SEEN: ', user?.tutorialStatus?.allSeen, user?.tutorialStatus?.dischargingSeen, shouldHide)
                break;

            case SlideHidePageCondition.INVITING_SLIDE_SEEN:
                //hide the slide if this slide has been marked as hidden
                shouldHide = user?.tutorialStatus?.allSeen || user?.tutorialStatus?.invitingSeen;
                //console.log('result -> INVITING_SLIDE_SEEN: ', user?.tutorialStatus?.allSeen, user?.tutorialStatus?.invitingSeen, shouldHide)
                break;

            case SlideHidePageCondition.USER_SEEN_ALL_VIDEOS:
                //hide the slide if this slide has been marked as hidden
                shouldHide = user?.tutorialStatus?.allSeen || (user?.tutorialStatus?.invitingSeen && user?.tutorialStatus?.schedulingSeen && user?.tutorialStatus?.dischargingSeen);
                //console.log('result -> USER_SEEN_ALL_VIDEOS: ', user?.tutorialStatus?.allSeen, user?.tutorialStatus?.invitingSeen, user?.tutorialStatus?.schedulingSeen, user?.tutorialStatus?.dischargingSeen, shouldHide)
                //console.log('USER_SEEN_ALL_VIDEOS RESULT: ', user?.tutorialStatus?.allSeen, user?.tutorialStatus?.invitingSeen, shouldHide)
                break;
            // case SlideHidePageCondition.FORCE_TUTORIAL_IS_TRUE:
            //     //hide the slide if the forceSlide is true or false
            //     if (user.forceSlide === true){
            //         const isAdminStaff = user?.userType !== 'doctor';
            //         shouldHide = isAdminStaff && groupUsers.userRole.toLowerCase() !== 'admin';
            //     }
            //     break;

            case SlideHidePageCondition.NONE:
            default:
                //by default, do not hide the slide
                shouldHide = false; // Default to not hiding the slide
                break;
        }
        //if shouldHide is TRUE we are going to HIDE the slide
        //if shouldHide is FALSE we are going to SHOW the slide
        return shouldHide;

    }

    //Persisting user progress
    // const updateUserProgress = (progressPercentege: number) => {
    //     if (!user) return; //If user doesnt exist return without fail
    //     user.progressBar = (user.progressBar || 0) + progressPercentege;

    //     //Send progress update to TutorialService for db persistance
    //     tutorialService.updateUserProgress(user.progressBar)
    // }

    // 1. Separate ANY vs ALL
    const anyConditions = conditions.filter(c => c.type === SlideHideConditionType.OR);
    const allConditions = conditions.filter(c => c.type === SlideHideConditionType.AND);
    //console.log('anyConditions: ', anyConditions);
    //console.log('allConditions: ', allConditions);


    // 2. ANY Conditions => OR
    for (const condition of anyConditions) {
        //console.log('EVALUATING ANY CONDITION: ', condition.condition);
        if (evaluateCondition(condition)) {
            // If *any* is true => hide the slide
            //console.log('ANY CONDITION MET, HIDE SLIDE: ', true);
            return true;
        }
    }

    // 3. ALL Conditions => AND
    if (allConditions.length > 0) {
        // We must confirm *every* one is true
        for (const condition of allConditions) {
            //console.log('ALL CONDITION: ', condition.condition);
            if (!evaluateCondition(condition)) {
                // If any is false => do not hide => return false
                //console.log('ALL CONDITION RESULT, SHOULD SHOW: ', false);
                return false;
            }
        }
        // If we made it here, allConditions are true => hide
        return true;
    }

    // 4. If no conditions matched hiding, return false (do not hide)
    return false;
}